import { Injectable } from '@angular/core';
import { CookiesOptionsService } from './cookies-options.service';
import { safeJsonParse } from './utils';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from './cookies-options.service';
var CookiesService = /** @class */ (function () {
    function CookiesService(cookiesOptions) {
        this.options = cookiesOptions.options;
    }
    CookiesService.prototype.put = function (key, value, options) {
        this.cookiesWriter()(key, value, options);
    };
    CookiesService.prototype.putObject = function (key, value, options) {
        this.put(key, JSON.stringify(value), options);
    };
    CookiesService.prototype.get = function (key) {
        return this.cookiesReader()[key];
    };
    CookiesService.prototype.getObject = function (key) {
        var value = this.get(key);
        return value ? safeJsonParse(value) : value;
    };
    CookiesService.prototype.getAll = function () {
        return this.cookiesReader();
    };
    CookiesService.prototype.remove = function (key, options) {
        this.cookiesWriter()(key, undefined, options);
    };
    CookiesService.prototype.removeAll = function () {
        var _this = this;
        var cookies = this.getAll();
        Object.keys(cookies).forEach(function (key) {
            _this.remove(key);
        });
    };
    CookiesService.prototype.cookiesReader = function () {
        return {};
    };
    CookiesService.prototype.cookiesWriter = function () {
        return function () { };
    };
    /** @nocollapse */
    CookiesService.ctorParameters = function () { return [
        { type: CookiesOptionsService, },
    ]; };
CookiesService.ɵfac = function CookiesService_Factory(t) { return new (t || CookiesService)(ɵngcc0.ɵɵinject(ɵngcc1.CookiesOptionsService)); };
CookiesService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CookiesService, factory: function (t) { return CookiesService.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CookiesService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.CookiesOptionsService }]; }, null); })();
    return CookiesService;
}());
export { CookiesService };

